import {
  OriginConnectionPosition,
  Overlay,
  OverlayConfig,
  OverlayConnectionPosition,
  OverlayRef,
  ScrollDispatcher,
} from '@angular/cdk/overlay';
import { TemplatePortalDirective } from '@angular/cdk/portal';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';

export type TooltipPosition =
  | 'top-start'
  | 'top-center'
  | 'top-end'
  | 'bottom-start'
  | 'bottom-center'
  | 'bottom-end'
  | 'start-top'
  | 'start-center'
  | 'start-bottom'
  | 'end-top'
  | 'end-center'
  | 'end-bottom';

// TODO: More features.
// - Animations (T38383)
// - Hide delay (T38384)
@Component({
  selector: 'fl-tooltip',
  template: `
    <ng-content></ng-content>
    <ng-template cdk-portal>
      <fl-tooltip-content [position]="position">
        {{message}}
      </fl-tooltip-content>
    </ng-template>
  `,
})
export class TooltipComponent implements OnInit, OnDestroy {
  @ViewChild(TemplatePortalDirective) portal: TemplatePortalDirective;
  @Input() message: string;
  @Input() position: TooltipPosition = 'bottom-center';

  private overlayRef?: OverlayRef;

  constructor(
    private overlay: Overlay,
    private elementRef: ElementRef,
    private scrollDispatcher: ScrollDispatcher,
  ) {}

  @HostListener('body:click')
  onBodyClick() {}
  @HostListener('mouseenter')
  onMouseenter() {
    this.show();
  }
  @HostListener('mouseleave')
  onMouseleave() {
    this.hide();
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.dispose();
  }

  show() {
    if (!this.message || !this.message.trim()) {
      return;
    }

    this.overlayRef = this.createOverlay();
    this.overlayRef.attach(this.portal);
  }

  hide() {
    this.dispose();
  }

  private dispose() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = undefined;
    }
  }

  private getOverlayPosition(): OverlayConnectionPosition {
    const position = this.position.split('-');

    const anchor = position[0];
    const relativePosition = position[1];

    if (
      (anchor === 'top' || anchor === 'bottom') &&
      (relativePosition === 'start' ||
        relativePosition === 'center' ||
        relativePosition === 'end')
    ) {
      return {
        overlayX: relativePosition,
        overlayY: anchor === 'top' ? 'bottom' : 'top',
      };
    }

    if (
      (anchor === 'start' || anchor === 'end') &&
      (relativePosition === 'top' ||
        relativePosition === 'center' ||
        relativePosition === 'bottom')
    ) {
      return {
        overlayX: anchor === 'start' ? 'end' : 'start',
        overlayY: relativePosition,
      };
    }

    throw Error('No position for tooltip specified!');
  }

  private getOrigin(): OriginConnectionPosition {
    const position = this.position.split('-');

    const anchor = position[0];
    const relativePosition = position[1];

    if (
      (anchor === 'top' || anchor === 'bottom') &&
      (relativePosition === 'start' ||
        relativePosition === 'center' ||
        relativePosition === 'end')
    ) {
      return { originX: relativePosition, originY: anchor };
    }

    if (
      (anchor === 'start' || anchor === 'end') &&
      (relativePosition === 'top' ||
        relativePosition === 'center' ||
        relativePosition === 'bottom')
    ) {
      return {
        originX: anchor,
        originY: relativePosition,
      };
    }

    throw Error('No position for tooltip specified!');
  }

  private createOverlay() {
    const origin = this.getOrigin();
    const position = this.getOverlayPosition();
    const strategy = this.overlay
      .position()
      .connectedTo(this.elementRef, origin, position);

    strategy.withScrollableContainers(
      this.scrollDispatcher.getScrollContainers(this.elementRef),
    );

    const state = new OverlayConfig();
    state.positionStrategy = strategy;

    return this.overlay.create(state);
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/app/@shared/ui/tooltip/tooltip.component.ts